/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import {
  OfficeMeasurement,
  OfficeMeasurementDefault,
  PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS,
} from '@gh/builder-shared-data';
import { whenEditMode, whenNzRegion } from '@gh/common-shared';

import { FormMode, getControlValue, setControlValue } from '@gh/core-ui';
import { SystemVarsEstimatingOrders } from '../../../resources/model/system-vars-estimating.model';

@Injectable()
export class SystemVarsEstimatingOrderSubTabFormState extends FormState<SystemVarsEstimatingOrders> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  build(orders: SystemVarsEstimatingOrders, mode: FormMode): void {
    this.setMode(mode);
    this.initSchema(orders);
  }

  resetMeasurementDefault(): void {
    setControlValue(this.group, 'measurementDefault', {
      [OfficeMeasurement.Imperial]: OfficeMeasurementDefault.Foot,
      [OfficeMeasurement.Metric]: void 0,
    }[getControlValue(this.group, 'measurementScale')]);
  }

  protected buildSchema(_: SystemVarsEstimatingOrders, { root }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenEditMode(),
      mode: this.mode,
      privilegedEntryPoints: [PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS],
      optimisticLock: true,
      children: {
        officeId: void 0,
        costCenter: { enabled: true },
        showDeliveryDate: { enabled: true },
        whenCombining: { enabled: true },
        noShowLogo: { enabled: true, privileged: [PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS] },
        showFrClause: { enabled: true, privileged: [PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS] },
        allowSupplierChange: { enabled: true, privileged: [PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS] },
        printRecordForm: { enabled: true, visible: whenNzRegion() },
        criteriaEstimate: { enabled: true },
        criteriaCouncil: { enabled: true },
        criteriaFinance: { enabled: true },
        criteriaColorSelection: { enabled: true },
        criteriaJobSchedule: { enabled: true },
        criteriaContract: { enabled: true },
        criteriaJobProceeding: { enabled: true },
        criteriaInsurancePolicy: { enabled: true },
        ordersMemo: void 0,
        ordersPlusRequiredText: void 0,
        ordersSendBackReceipt: void 0,
      },
    });
  }
}
